export enum DOCUMENT_STATE_TYPE {
  INDICATIVE = 'INDICATIVE',
  FINAL = 'FINAL',
}
